module.exports = __webpack_public_path__ + "static/media/purple-l.86b05074.svg";